import mixpanelCl from '@src/telemetry/integrations/mixpanel'
import { deleteCookie } from './index'
import AuthUtil from '@src/quince-site-common/src/utils/authUtil'

const isBrowser = typeof window !== `undefined`

export const setUser = user => {
  // window.localStorage.setItem('gatsbyUser', JSON.stringify(user))
}

export const logout = callback => {
  if (!isBrowser) return
  setUser({})
  deleteCookie('jwt_token_valid_checkout')
  mixpanelCl.reset()
  callback()
}

export const isLoggedIn = () => {
  return AuthUtil.isLoggedIn()
}

export const getCurrentUser = () => isBrowser && AuthUtil.getUser()
